import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dibujo',
  templateUrl: './dibujo.component.html',
  styleUrls: ['./dibujo.component.scss']
})
export class DibujoComponent implements OnInit {

  public imagenes = [{"titulo":"M22", "imagen":"./assets/dibujo1.png","creador":"Nicolas Arias"}];

  constructor() { }

  ngOnInit(): void {
  }

}
